import { ActionTypes } from '../actions/types';

const initialState = {
  auftragsvorlageliste: [],
  reloadToggle: false,
  totalSearchResults: undefined,
};

export default function (
  state = initialState,
  action: { type: ActionTypes; payload: any }
) {
  const { type, payload } = action;

  switch (type) {
    case ActionTypes.SEARCH_AUFTRAGSVORLAGE: {
      return {
        ...state,
        auftragsvorlageliste: payload,
      };
    }
    case ActionTypes.RELOAD_AUFTRAGSVORLAGE_MANAGEMENT: {
      return {
        ...state,
        reloadToggle: !state.reloadToggle,
      };
    }
    case ActionTypes.SET_TOTALSEARCHRESULTS: {
      return {
        ...state,
        totalSearchResults: payload,
      };
    }
    default:
      return state;
  }
  return state;
}
